import React, { FC, MouseEvent, ButtonHTMLAttributes } from "react";

import classnames from "classnames";

import { StyledCompleteCheckbox } from "./Styles";

export interface ICompleteCheckboxProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Change completed state of checkbox */
  completed?: boolean;
  /** Callback */
  onClick?: (event: MouseEvent) => void;
  /** Make component disabled for interaction */
  disabled?: boolean;
  /** Animation (works only when is completed and not disabled) */
  animate?: boolean;
  /** Class names */
  className?: string | undefined;
  /** Set green color for checkbox */
  primary?: boolean;
  /** Set checkmark height and width */
  checkMarkClassName?: string;
}

export const CompleteCheckbox: FC<ICompleteCheckboxProps> = ({
  completed = false,
  disabled = false,
  animate = false,
  onClick,
  className,
  primary = false,
  checkMarkClassName,
  ...rest
}) => {
  return (
    <StyledCompleteCheckbox
      onClick={onClick}
      className={classnames("c-complete-checkbox", className)}
      $primary={primary}
      $completed={completed}
      $disabled={disabled}
      $animation={!disabled && completed && animate}
      $checkMarkClassName={!!checkMarkClassName}
      {...rest}
    >
      <svg viewBox="0 0 48 48" className={checkMarkClassName}>
        <path d="M7,7l5.7,5.7 M0,24h8 M7,41l5.7-5.7 M24,48v-8 M41,41l-5.7-5.7 M48,24h-8 M41,7l-5.7,5.7 M24,0v8" />
        <polyline points="19.5,24 22.5,27 28.5,21" />
      </svg>
    </StyledCompleteCheckbox>
  );
};

CompleteCheckbox.displayName = "CompleteCheckbox";
